import { FC } from "react";

export const CardInfoContainer: FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="grid grid-cols-1 gap-x-2 gap-y-9 lg:grid-cols-2 xl:grid-cols-1 2xl:grid-cols-2">
      {children}
    </div>
  );
};
